import React from 'react';
import { finalCta } from '../../mock';

const FinalCTA = () => {
  return (
    <section id="activate" className="relative w-full min-h-[80vh] overflow-hidden bg-navy">
      <div className="absolute inset-0">
        <img
          src={finalCta.image}
          alt="Sunset"
          className="w-full h-full object-cover kenburns"
          loading="lazy"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/25 via-black/25 to-black/60" />
      </div>

      <div className="relative z-10 max-w-3xl mx-auto text-center px-6 md:px-10 py-32 md:py-44">
        <div className="gold-divider mb-6">
          <span className="chapter-badge text-white/90 uppercase">The Final Chapter</span>
        </div>
        <h2 className="font-serif-display text-white text-4xl md:text-6xl leading-[1.1] font-medium">
          {finalCta.headline}
        </h2>
        <p className="mt-6 font-serif-editorial text-white/85 text-xl md:text-2xl leading-relaxed">
          {finalCta.sub}
        </p>
        <div className="mt-10">
          <a href="/activate" className="btn-gold inline-block">
            {finalCta.cta}
          </a>
        </div>
      </div>
    </section>
  );
};

export default FinalCTA;
